import StackAPI from '@/lib/StackAPI'
import { captureException } from '@sentry/react'
import { Filters } from '../types/PhysicalOrders'

const PATH = '/partners/vendor/orders/batches'
const ERROR = 'Failed to download. Try again later.'

export type GetBatchCsvParams = {
  batchId?: number
  batchIds?: number[]
  filters?: Filters
}

const getBatchCsv = async ({
  batchId,
  batchIds,
  filters = {}
}: GetBatchCsvParams) => {
  const { get } = StackAPI()
  const path = batchId ? `${PATH}/${batchId}` : PATH

  return get({
    path,
    params: {
      batch_ids: batchIds,
      filter_by_late: filters.late ? 1 : null,
      filter_by_pending: filters.pending ? 1 : null,
      filter_by_refunded: filters.refunded ? 1 : null
    }
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      captureException(error)
      return { error: ERROR }
    })
}

export default getBatchCsv
